import axios from 'config/api';
import { FETCH_CATEGORIES_SUCCESS } from 'config/constants';

export function fetchCategories() {
  return axios
    .get(`/categories`)
    .then(({ data, status }) => {
      if (status === 200) {
        return {
          type: FETCH_CATEGORIES_SUCCESS,
          categories: data,
        };
      }

      throw new Error();
    })
    .catch(error => {
      console.error('Por favor, entre em contato com o suporte.', error);
      throw error;
    });
}
